export default __webpack_public_path__ + "static/media/hard-disk.d04c9759.svg";